<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html {
  background: #151217;
  font-family: "Alata", Arial, sans-serif;
}

body {
  margin: 0;
  background: #151217;
  color: #1f1b20;
  font-family: "Alata", Arial, sans-serif;
  font-synthesis: none;
  overflow-x: hidden;
  text-rendering: optimizeLegibility;
}

* {
  box-sizing: border-box;
}

button,
input,
select,
textarea {
  font: inherit;
}

a {
  font-family: inherit;
}

#app {
  min-height: 100vh;
  overflow-x: hidden;
}
</style>
